<div class="card mb-5" [class.price-dynamics-popup]="data?.chartConfig?.presentation === 'price-dynamics-popup'">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <div class="title-row">
        <h4>{{ data.title | capitalCase }}</h4>
        <span class="unit-badge" *ngIf="data?.chartConfig?.unitBadge">{{ data.chartConfig.unitBadge }}</span>
      </div>
      <p class="chart-subtitle" *ngIf="priceDynamicsSubtitle || data?.subtitle">{{ priceDynamicsSubtitle || data.subtitle }}</p>
    </div>
  </div>
  <div class="card-body">
    <div class="year-range-row" *ngIf="availablePriceDynamicsYears.length || data?.chartConfig?.yearRange">
      <span>Year Range:</span>
      <select [(ngModel)]="selectedPriceDynamicsFromYear" (ngModelChange)="onPriceDynamicsFromYearChange($event)">
        <option *ngFor="let year of getAvailableFromYears()" [value]="year">{{ year }}</option>
      </select>
      <span>to</span>
      <select [(ngModel)]="selectedPriceDynamicsToYear" (ngModelChange)="onPriceDynamicsToYearChange($event)">
        <option *ngFor="let year of getAvailableToYears()" [value]="year">{{ year }}</option>
      </select>
    </div>
    <div
      id="{{data.widgetId}}"
      [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'"
      style="width: 100%"
    ></div>
  </div>
  <div class="strength-band" *ngIf="data?.chartConfig?.strengthBand">
    <span>{{ data.chartConfig.strengthBand.label }}</span>
    <strong>{{ data.chartConfig.strengthBand.value }}</strong>
  </div>
  <div
    class="footer-metrics"
    *ngIf="priceDynamicsFooterMetrics.length || data?.chartConfig?.footerMetrics?.length"
    [style.--metric-count]="(priceDynamicsFooterMetrics.length ? priceDynamicsFooterMetrics : data.chartConfig.footerMetrics).length"
  >
    <div class="footer-metric" *ngFor="let metric of (priceDynamicsFooterMetrics.length ? priceDynamicsFooterMetrics : data.chartConfig.footerMetrics)">
      <span>{{ metric.label }}</span>
      <strong [class.positive]="metric.highlight === 'positive'" [class.negative]="metric.highlight === 'negative'">
        {{ metric.value }}
      </strong>
    </div>
  </div>
</div>
